import { Icon } from '@hotjar/hotsauce';
import { useModalTrackingCode } from '@hotjar/webapp/hooks/useModalTrackingCode';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';
import { useCurrentSite } from '@hotjar/site';
import { WidgetContainer } from './Widget';

interface TrackingBasicProps {
  trackIndicatorClick: (elementName: string) => void;
}

export const TrackingBasic = ({ trackIndicatorClick }: TrackingBasicProps): JSX.Element => {
  const currentSite = useCurrentSite().data;
  const { clickedTrackingActive } = useTrack();
  const { show } = useModalTrackingCode();

  const handleClick = () => {
    if (!currentSite) {
      return;
    }
    trackIndicatorClick('traffic_basic_traffic_coverage_indicator');

    clickedTrackingActive();

    show(currentSite, 1, 'Tracking State Button');
  };

  return (
    <WidgetContainer
      onClick={handleClick}
      iconComponent={<Icon color="text_default" icon="check" size="m" />}
      text="Tracking"
    />
  );
};
